import { proxyFetch } from '@ps/functions/utils/proxyFetch';

export interface PostStats {
  likeCount: number;
  commentCount: number;
}

/** Public like + comment counts (server-cached for days under `post/<id>/stats`). */
export function fetchPostStats(
  storeId: string,
  postId: string,
): Promise<PostStats> {
  const params = new URLSearchParams({ storeId, postId });
  return proxyFetch<PostStats>(`/api/bio/posts/stats?${params.toString()}`);
}

/** Whether the CALLER has liked the post (per-viewer; not server-cached). */
export function fetchPostLiked(
  storeId: string,
  postId: string,
): Promise<{ liked: boolean }> {
  const params = new URLSearchParams({ storeId, postId });
  return proxyFetch<{ liked: boolean }>(
    `/api/bio/posts/liked?${params.toString()}`,
  );
}

/**
 * Bust the post's cached stats so the next {@link fetchPostStats} is fresh. Used
 * after a comment submit — comments are created via the client `PostsApi`, so
 * there's no server route to revalidate inline (the like route does it itself).
 */
export function revalidatePostStats(postId: string): Promise<void> {
  return proxyFetch('/api/bio/posts/revalidate-stats', {
    method: 'POST',
    body: { postId },
  });
}
